import { Loader } from "@/components/loader/Loader.tsx";
import { MeetingFlexQualifier } from "@/components/artifacts/omni/ProtectedMeetingsOmniPickerBody.tsx";
import { OmniPickerRow } from "@/components/artifacts/omni/OmniPickerRow.tsx";
import { useFlexibleMeetings } from "@/components/scheduling/useFlexibleMeetings.ts";
import { describeRecurrence } from "@/shared/recurrenceLabel.ts";

export const ProtectedMeetings = () => {
  const { series, isLoading, isSaving, canMove, toggle, protectedCount } = useFlexibleMeetings();

  if (isLoading) {
    return (
      <div className="flex items-center justify-center py-8">
        <Loader size="sm" />
      </div>
    );
  }

  if (series.length === 0) {
    return (
      <p className="text-sm text-muted-foreground italic">
        No frequent recurring meetings found on your selected calendars.
      </p>
    );
  }

  return (
    <div className="space-y-3">
      <div className="bg-white rounded-2xl">
        {series.map((s, idx) => {
          const isMovable = canMove(s.externalRecurringEventId);

          return (
            <div key={s.externalRecurringEventId}>
              {idx > 0 && <div className="border-t-[0.5px] border-border" />}
              {/* The same row the omnibox picker card uses, so the checkbox
                  is the interaction on every surface — checked means the
                  scheduler may move it. */}
              <OmniPickerRow
                checked={isMovable}
                onToggle={() => void toggle(s.externalRecurringEventId)}
                disabled={isSaving}
                label={s.subject}
                sublabel={[describeRecurrence(s), s.location].filter(Boolean).join(" · ")}
                qualifier={<MeetingFlexQualifier isMovable={isMovable} />}
                ariaState={isMovable ? "Flexible" : "Protected"}
                // Protected is the resting state, not "off" — an unchecked
                // row is not dimmer than a checked one.
                dimUnchecked={false}
                statsigName="settings-protected-meeting-toggle"
                className="px-4 py-3 hover:bg-secondary/50"
              />
            </div>
          );
        })}
      </div>
      <p className="text-sm text-muted-foreground italic px-1">
        You have {series.length} recurring meeting
        {series.length !== 1 ? "s" : ""}, {protectedCount} protected. Flexible meetings may be used
        as fallback times by the scheduler.
      </p>
    </div>
  );
};
